import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
} from 'ionic-angular';

import { VehicleMakeModel } from './../../models/vehicle-make';
import { VehicleProvider } from './../../providers/vehicle/vehicle';

@IonicPage()
@Component({
  selector: 'page-select-vehicle-make',
  templateUrl: 'select-vehicle-make.html',
})
export class SelectVehicleMakePage {
  makes: VehicleMakeModel[] = [];
  filteredMakes: VehicleMakeModel[];
  isModal: boolean;
  query: string;
  selectedMake: VehicleMakeModel;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private vehicleService: VehicleProvider,
    private viewCtrl: ViewController
  ) {
    this.isModal = navParams.get('modal');
    this.vehicleService.getCarMakes().subscribe(makes => {
      this.makes = makes || [];
      this.filteredMakes = makes;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectVehicleMakePage');
  }

  filterMakes() {
    this.filteredMakes = this.makes.filter(make => {
      return make.make.toLowerCase().includes(this.query.toLowerCase());
    });
  }

  didSelectMake(make: VehicleMakeModel) {
    this.selectedMake = make;
    this.dismiss();
  }

  dismiss() {
    this.isModal
      ? this.viewCtrl.dismiss(this.selectedMake)
      : this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-vehicle-make/select-vehicle-make.ts